import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { ApiError, errorMessage } from '@/lib/api';
import { toast } from '@/store/ui';

/** Map server validation errors onto form fields; fall back to a toast. */
export function handleFormError<T extends FieldValues>(err: unknown, setError: UseFormSetError<T>, title = 'Could not save') {
  if (err instanceof ApiError) {
    const fields = err.fieldErrors;
    const keys = Object.keys(fields);
    for (const k of keys) setError(k as Path<T>, { message: fields[k] });
    if (keys.length) return;
  }
  toast.error(title, errorMessage(err));
}

/** Empty strings → undefined so optional API fields are omitted rather than sent blank. */
export function compact<T extends Record<string, unknown>>(obj: T): T {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) out[k] = v === '' ? undefined : v;
  return out as T;
}
